import React from "react";

const Bash_Free = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Free</h2>
      <p>Display memory usage.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>free [options]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>free -h</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Shows total, used, and available memory.</p>
    </div>
  );
};

export default Bash_Free;
